/* @flow */

import * as React from 'react';

import {EmptyStateSmall} from 'shells/empty-states';
import {MagnifyingGlassEmptyState} from 'shells/illustrations';

import './nothing-found-empty-state.module.css';

type Props = {
    title?: string,
    subtitle?: React.Node | string,
    icon?: React.Node,
};

export function NothingFoundEmptyState(props: Props) {
    const icon = props.icon || (
        <div styleName='icon-container'>
            <MagnifyingGlassEmptyState />
        </div>
    );

    return (
        <EmptyStateSmall
            title={props.title || 'Nothing found'}
            subtitle={props.subtitle || 'Try loosening your search!'}
            icon={icon}
        />
    );
}
